import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import echoPromise from './lib/echo'; // Import Echo initialization

// Initialize PostHog
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost || 'https://us.i.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    debug: import.meta.env.MODE === 'development',
    disable_external_dependency_loading: true, // Prevent PostHog from loading Clarity
  });
  // Expose for testing
  (window as any).posthog = posthog;
}

// Recarrega a página quando um chunk lazy falha — caso usuário tenha bundle
// antigo em cache tentando importar um chunk que já foi removido por deploy novo.
// Throttle via sessionStorage evita loop infinito se o chunk estiver realmente
// indisponível (offline, deploy quebrado, etc).
window.addEventListener('vite:preloadError', () => {
  const RELOAD_KEY = 'vite-preload-error-reload-at';
  const THROTTLE_MS = 30_000;
  const now = Date.now();
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
  if (now - last > THROTTLE_MS) {
    sessionStorage.setItem(RELOAD_KEY, String(now));
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Initialize Echo and then render the app
(async () => {
  try {
    console.log('[Main] Initializing Echo...');
    await echoPromise; // Wait for Echo to be initialized
    console.log('[Main] Echo initialized successfully:', !!window.Echo);
  } catch (error) {
    console.error('[Main] Failed to initialize Echo:', error);
    // Continue rendering even if Echo fails (fallback to polling will be used)
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PostHogProvider>
    </React.StrictMode>
  );
})();
